import {DefaultOptionType} from 'antd/es/select';

import {ProtocolEnum} from '../../../../../../../../service/company-v2/company-const';

export function getProtocolOptions(
    httpsOnly: boolean,
    showMessengerOptions: boolean,
    showMaxOption: boolean
): Array<DefaultOptionType> {
    const options: Array<DefaultOptionType> = [
        ...(httpsOnly ? [] : [{value: ProtocolEnum.HTTP, label: ProtocolEnum.HTTP}]),
        {value: ProtocolEnum.HTTPS, label: ProtocolEnum.HTTPS},
    ];

    if (showMessengerOptions) {
        options.push({value: ProtocolEnum.WHATSAPP, label: 'WhatsApp'}, {value: ProtocolEnum.VIBER, label: 'Viber'});
    }

    // MAX is never count-capped on the client — the backend owns the "max 3 links" rule.
    if (showMaxOption) {
        options.push({value: ProtocolEnum.MAX, label: 'MAX'});
    }

    return options;
}
